import { ProjectType } from '@prisma/client';

export const projectTypeTitleByCanonicalType: Record<ProjectType, string> = {
  [ProjectType.REFORESTATION]: 'Native tree planting',
  [ProjectType.FORESTRY]: 'Deforestation prevention',
  [ProjectType.CAPTURE]: 'Greenhouse gas capture',
  [ProjectType.WETLANDS]: 'Wetland restoration',
  [ProjectType.RENEWABLES]: 'Renewable energy',
  [ProjectType.COMMUNITY]: 'Community based',
  [ProjectType.TRANSPORT]: 'Efficient transportation',
  [ProjectType.GEOTHERMAL]: 'Geothermal',
  [ProjectType.HOUSEHOLD_RETROFIT]: 'Household Retrofit',
  [ProjectType.AFFORESTATION_REFORESTATION_AND_REVEGETATION]: 'ARR',
  [ProjectType.BIOCHAR]: 'Biochar',
  [ProjectType.BLUE_CARBON]: 'Blue carbon',
  [ProjectType.DIRECT_AIR_CAPTURE]: 'Direct air capture',
  [ProjectType.ENHANCED_ROCK_WEATHERING]: 'Enhanced rock weathering',
  [ProjectType.REGENERATIVE_AGRICULTURE]: 'Regenerative agriculture',
  [ProjectType.WILDFLOWERS]: 'Wildflowers',
  [ProjectType.SEAGRASS]: 'Seagrass',
  [ProjectType.PEATLANDS]: 'Peatlands',
  [ProjectType.RAINFOREST_PROTECTION]: 'Rainforest protection',
  [ProjectType.MARINE_PROTECTION_RESTORATION]: 'Marine protection and restoration',
};

export const getProjectTypeTitle = (projectType?: ProjectType | null): string | undefined =>
  projectType ? projectTypeTitleByCanonicalType[projectType] : undefined;
